import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import * as sessionUserSelector from 'selectors/sessionUser'

import { userTimeZoneFormat } from 'utils/time'

import Table from 'components/Shared/TableNew/Index'
import TableHead from 'components/Shared/TableNew/TableHead'
import TableBody from 'components/Shared/TableNew/TableBody'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import TableRowNoData from 'components/Shared/TableNew/TableRowNoData'
import EnabledIcon from 'components/Shared/EnabledIcon/Index'
import SatComplianceBadge from 'components/App/SatClientsPage/shared/SatComplianceBadge'

const SatSecretsTable = ({ satSecrets }) => {
  const { t } = useTranslation()

  const userTimeZone = useSelector(sessionUserSelector.timezone)

  return (
    <Table width='100%'>
      <TableHead>
        <TableRow>
          <TableCell>{t('satSecretsPage.table.lastFour')}</TableCell>
          <TableCell align='center'>{t('satSecretsPage.table.active')}</TableCell>
          <TableCell>{t('satSecretsPage.table.compliance')}</TableCell>
          <TableCell>{t('satSecretsPage.table.expiresAt')}</TableCell>
          <TableCell>{t('satSecretsPage.table.lastUsedAt')}</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {satSecrets.map(satSecret =>
          <TableRow key={satSecret.id}>
            <TableCell>{satSecret.lastFour}</TableCell>
            <TableCell align='center'>
              <EnabledIcon enabled={satSecret.active} />
            </TableCell>
            <TableCell>
              <SatComplianceBadge status={satSecret.complianceStatus} />
            </TableCell>
            <TableCell>{userTimeZoneFormat(userTimeZone, satSecret.expiresAt)}</TableCell>
            <TableCell>{userTimeZoneFormat(userTimeZone, satSecret.lastUsedAt)}</TableCell>
          </TableRow>
        )}

        <TableRowNoData data={satSecrets} />
      </TableBody>
    </Table>
  )
}

SatSecretsTable.propTypes = {
  satSecrets: PropTypes.array.isRequired,
}

export default SatSecretsTable
